/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Silly_Inner_Jay_FryInputs */

const fr_silly_inner_jay_fry = /** @type {(inputs: Silly_Inner_Jay_FryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abdos EMOM 12'`)
};

/**

* @param {Silly_Inner_Jay_FryInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const silly_inner_jay_fry = /** @type {((inputs?: Silly_Inner_Jay_FryInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Silly_Inner_Jay_FryInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_silly_inner_jay_fry(inputs)
});